import {
  EditorState,
} from 'draft-js';

export type FieldType = 'InputField' | 'GoogleMapField' | 'GalleryField'
| 'MultipleSelectField' | 'DropdownField' | 'RichTextField' | 'ToggleButtonField' | 'DatePickerField'
| 'AutoScheduledField' | 'SearchSelectField' | 'ColorPickerField';

export interface IInputField {
  filedType: FieldType;
  name: string;
  label: string;
  type: string;
  value?: string;
  suffix?: string;
  multiLine?: boolean;
  rowsMax?: number;
  disabled?: boolean;
}

export interface IMultipleSelectField {
  filedType: FieldType;
  name: string;
  label: string;
  selectList: [];
  selectListKey: string;
  selectListValue: string;
  value?: any[];
}

export interface IGoogleMapField {
  filedType: FieldType;
  name: string;
  label: string;
  value?: {
    latitude: number;
    longitude: number;
  };
}

export interface IGalleryField {
  filedType: FieldType;
  name: string;
  label: string;
  isLimitToOneImage?: boolean;
  value?: any[];
  accept?: string; //  'video/*,image/*' or 'image/*'
  textMessage?: string;
  ratio?: number;
  size?: number;
  warningMessage?: string;
  processing?: boolean;
  hideProgressBar?: boolean;
}

export interface IDropdownField {
  filedType: FieldType;
  name: string;
  label: string;
  selectList: any[];
  selectListKey: string;
  selectListValue: string;
  value?: any;
}

export interface IRichTextField {
  filedType: FieldType;
  name: string;
  label: string;
  value?: EditorState;
}

export interface IToggleButtonField {
  filedType: FieldType;
  name: string;
  label?: string;
  value?: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
}

export interface IDatePickerField {
  filedType: FieldType;
  name: string;
  label: string;
  value?: Date;
  minDate?: Date;
  withTimePicker?: boolean;
}

export interface IAutoScheduledField {
  filedType: FieldType;
  label: string;
  name: string;
  value?: {
    toggle?: boolean;
    startDate?: Date;
    endDate?: Date;
  };
  toggle: IToggleButtonField;
  startDate: IDatePickerField;
  endDate: IDatePickerField;
}

export interface ISearchSelectField {
  filedType: FieldType;
  name: string;
  label: string;
  selectList: any[];
  selectListKey: string;
  selectListValue: string;
  value?: any;
}

export interface IColorPickerField {
  filedType: FieldType;
  name: string;
  label: string;
  value?: string;
  color: string;
}

export type FormField = IInputField | IGoogleMapField | IGalleryField
| IMultipleSelectField | IDropdownField | IRichTextField | IToggleButtonField
| IDatePickerField | IAutoScheduledField | ISearchSelectField | IColorPickerField;

export function isDropdownField(field: FormField): field is IDropdownField {
  return field.filedType === 'DropdownField';
}
